import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  title: {
    color: '#003353',
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 32,
    marginBottom: 20,
  },
  fileWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  fileName: {
    color: '#00A0F3',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24,
    marginLeft: 10.5,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  itemLabel: {
    color: '#668598',
    fontSize: 16,
    lineHeight: 24,
  },
  itemValue: {
    color: '#335C75',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '500',
  },
  statusLabel: {
    color: '#23BD86',
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '500',
  },
  downArrowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  amountContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: '#EBEEEF',
    paddingVertical: 23,
  },
  amountLabel: {
    color: '#003353',
    fontSize: 18,
    lineHeight: 24,
    fontWeight: '500',
  },
  amountValue: {
    color: '#003353',
    fontSize: 18,
    lineHeight: 24,
    fontWeight: '600',
  },
})
